import request from '@/utils/request'

//列表接口
export function getInformList(params) {
  return request({
    url: '/api/information/getList',
    method: 'get',
    params
  });
}
//详情接口
// export function getInfo(id) {
//   return request({
//     url: '/api/information/info/'+id,
//     method: 'get',
//   });
// }
export function getInfo(params) {
  return request({
    url: '/api/information/info',
    method: 'get',
    params
  });
}
//点赞
export function addlikes(data) {
  return request({
    url: '/api/information/likes',
    method: 'post',
    data,
    'content-type': 'application/x-www-form-urlencoded'
  });
}
//取消点赞
export function addunLikes(data) {
  return request({
    url: '/api/information/unLikes',
    method: 'post',
    data,
    'Content-Type': 'application/x-www-form-urlencoded'
  });
}
//增加浏览量
export function addViews(data) {
  return request({
    url: '/api/information/addViews',
    method: 'post',
    data
  });
}
//我的点赞
export function getMyLikeQueryPage(params) {
  return request({
    url: '/api/information/getMyLikeQueryPage',
    method: 'get',
    params
  });
}



// WEBPACK FOOTER //
// ./src/api/information/index.js